/**
 * Auth Feature Routes -- Product Portal
 */
import type { RouteRecordRaw } from 'vue-router';
import { useAuthStore } from '@/stores';

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: {
      title: 'Login',
      requiresAuth: false,
      layout: 'blank',
    },
  },
  // Shown instead of /login when a session is already active on this
  // device (e.g. an invite email link opened on a shared workstation) —
  // see authGuard's redirect in router/guards.ts.
  {
    path: '/active-session',
    name: 'active-session',
    component: () => import('./views/ActiveSessionView.vue'),
    meta: {
      title: 'Someone else is signed in',
      requiresAuth: false,
      layout: 'blank',
    },
    beforeEnter: () => {
      const authStore = useAuthStore();
      return authStore.isAuthenticated ? undefined : { name: 'login' };
    },
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('@/views/ResetPasswordView.vue'),
    meta: {
      title: 'Reset Password',
      requiresAuth: false,
      layout: 'blank',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/ForgotPasswordView.vue'),
    meta: {
      title: 'Forgot Password',
      requiresAuth: false,
      layout: 'blank',
    },
  },
  {
    path: '/callback',
    name: 'oidc-callback',
    component: () => import('./views/OidcCallbackView.vue'),
    meta: {
      title: 'Signing in...',
      requiresAuth: false,
      layout: 'blank',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/LogoutView.vue'),
    meta: {
      requiresAuth: false,
      layout: 'blank',
    },
  },
  {
    path: '/mfa-setup',
    name: 'mfa-setup',
    component: () => import('./views/MfaSetupView.vue'),
    meta: {
      title: 'Set Up Two-Factor Authentication',
      requiresAuth: false,
      layout: 'blank',
    },
  },
  {
    path: '/mfa',
    name: 'mfa-challenge',
    component: () => import('./views/MfaChallengeView.vue'),
    meta: {
      title: 'Two-Factor Authentication',
      requiresAuth: false,
      layout: 'blank',
    },
  },
];
